export const containerStyles = {
  pt: { md: 12.5, lg: 17.5 },
  pb: { md: 12.5, lg: 17.5 },
  position: "relative",
};

export const roadContainerStyles = {
  position: "absolute",
  left: 0,
  top: { md: "-14%", lg: 0 },
  height: "100%",
  width: "100%",
  zIndex: -1,
};

export const roadIconStyles = {
  width: "100%",
  overflow: "hidden",
  position: "absolute",
  top: 0,
  left: 0,
  "& svg": {
    width: "100%",
  },
};
